(() => {
  if (window.__bpAppDownloadPopup) {
    window.__bpAppDownloadPopup.init(document);
    return;
  }
  const selector = '[data-bp-app-download]';
  const storageKey = 'bp_app_invite_minimized_v1';
  const windowKey = 'bp_app_offer_window_v1';
  const endpoint = '/apps/secret-pass/app-offer/eligibility';
  const instances = new Map();
  const nativeApp = /BeautyPriceApp\/|Shopney/i.test(navigator.userAgent || '');
  const nativeOfferAllowed = () => {
    const path = (window.location.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/|$)/i, '').replace(/\/+$/, '') || '/');
    if (/^\/customer_authentication(?:\/|$)/i.test(path) || /^\/apps\/secret-pass(?:\/|$)/i.test(path)) return false;
    return path === '/';
  };
  const platform = () => {
    const ua = navigator.userAgent || '';
    if (/Android/i.test(ua)) return 'android';
    if (/iPhone|iPod|iPad/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) return 'ios';
    return 'other';
  };
  const read = (storage, key) => { try { return storage.getItem(key); } catch { return null; } };
  const remember = (minimized) => { try { sessionStorage.setItem(storageKey, minimized ? '1' : '0'); } catch {} };
  const visible = (element) => {
    if (element.closest('[hidden], [inert], [aria-hidden="true"]')) return false;
    const style = getComputedStyle(element);
    const rect = element.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) !== 0 && rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight && rect.right > 0 && rect.left < innerWidth;
  };
  const blocked = () => {
    if (document.body.matches('.page-overlay-cart-on, .menu-open, .menu-drawer-overlay-on, .search-overlay-on, .overflow-hidden')) return true;
    if (document.activeElement?.matches('input:not([type="button"]):not([type="submit"]):not([type="checkbox"]):not([type="radio"]), textarea, select, [contenteditable="true"]')) return true;
    return [...document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"], #shopify-pc__banner')].some(visible);
  };
  let frame = 0;
  const update = () => {
    frame = 0;
    const suppressed = blocked();
    instances.forEach((instance, root) => { root.dataset.suppressed = String(suppressed); });
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
  const observer = new MutationObserver(schedule);
  const rootsIn = (scope) => {
    const roots = scope.matches?.(selector) ? [scope] : [];
    scope.querySelectorAll?.(selector).forEach((root) => roots.push(root));
    return roots;
  };
  const init = (scope) => {
    rootsIn(scope).forEach((root) => {
      if (instances.has(root)) return;
      const panel = root.querySelector('[data-bp-app-panel]');
      const close = root.querySelector('[data-bp-app-close]');
      const launcher = root.querySelector('[data-bp-app-launcher]');
      const nativeCard = root.querySelector('[data-bp-native-card]');
      const nativePeriod = root.querySelector('[data-bp-native-period]');
      const terms = root.querySelector('[data-bp-offer-terms]');
      const period = root.querySelector('[data-bp-offer-period]');
      if (!panel || !close || !launcher || !nativeCard || !nativePeriod || !terms || !period) return;
      const controller = new AbortController();
      let requestController = null;
      let requestedAgain = false;
      let deadlineTimer = null;
      let revealTimer = null;
      let requestTimer = null;
      let alive = true;
      let generation = 0;
      root.dataset.platform = platform();
      root.dataset.state = 'pending';
      panel.hidden = true;
      launcher.hidden = true;
      nativeCard.hidden = true;
      close.hidden = nativeApp;
      if (nativeApp) root.dataset.nativeApp = 'true';
      root.closest('.bp-app-download-section')?.removeAttribute('data-bp-popup-loading');
      const conceal = () => {
        clearTimeout(revealTimer);
        clearTimeout(deadlineTimer);
        root.dataset.state = 'pending';
        panel.hidden = true;
        launcher.hidden = true;
        nativeCard.hidden = true;
        launcher.setAttribute('aria-expanded', 'false');
      };
      const setState = (state) => {
        root.dataset.state = state;
        panel.hidden = state !== 'open';
        launcher.hidden = state !== 'minimized';
        launcher.setAttribute('aria-expanded', String(state === 'open'));
      };
      const minimize = () => {
        const ownedFocus = root.contains(document.activeElement);
        setState('minimized');
        remember(true);
        if (ownedFocus) launcher.focus({ preventScroll: true });
      };
      const open = () => { setState('open'); remember(false); };
      const refresh = () => {
        if (!alive) return;
        if (requestController) { requestedAgain = true; return; }
        conceal();
        const current = ++generation;
        const request = new AbortController();
        requestController = request;
        const token = (() => { try { return localStorage.getItem(windowKey); } catch { return null; } })();
        const responsePromise = fetch(endpoint, {
          method: 'POST', credentials: 'same-origin', cache: 'no-store',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ window_token: token || null, begin: nativeApp }),
          signal: request.signal
        }).then((response) => {
          if (!response.ok) throw Error('eligibility_unavailable');
          return response.json();
        });
        const timeoutPromise = new Promise((_, reject) => {
          requestTimer = setTimeout(() => {
            request.abort();
            reject(Error('eligibility_timeout'));
          }, 10000);
        });
        Promise.race([responsePromise, timeoutPromise]).then((data) => {
          if (!alive || current !== generation) return;
          if (typeof data.window_token === 'string' && data.window_token) {
            try {
              if (!localStorage.getItem(windowKey)) localStorage.setItem(windowKey, data.window_token);
            } catch {}
          }
          if (requestedAgain) return;
          if (data.suppress === true || ['used', 'expired', 'unavailable'].includes(data.state)) return;
          if (!['login', 'available', 'ready', 'pending'].includes(data.state)) return;
          if (Number.isFinite(data.expires_at) && Number.isFinite(data.server_now)) {
            const remaining = Math.max(0, (data.expires_at - data.server_now) * 1000);
            if (!remaining) return;
            deadlineTimer = setTimeout(() => { conceal(); refresh(); }, Math.min(remaining, 2147483647));
          }
          // Existing grants without a deadline retain their original terms.
          const legacy = data.state === 'ready' && data.expires_at === null;
          terms.textContent = legacy ? terms.dataset.legacyCopy : terms.dataset.windowCopy;
          period.textContent = legacy ? period.dataset.legacyCopy : period.dataset.windowCopy;
          nativePeriod.textContent = legacy ? nativePeriod.dataset.legacyCopy : nativePeriod.dataset.windowCopy;
          if (nativeApp) {
            if (nativeOfferAllowed()) { nativeCard.hidden = false; root.dataset.state = 'native'; }
          } else {
            const editing = Boolean(window.Shopify?.designMode);
            if (read(sessionStorage, storageKey) === '1' && !editing) setState('minimized');
            else if (editing) setState('open');
            else revealTimer = setTimeout(() => { if (alive && current === generation) setState('open'); }, 2500);
          }
        }).catch(() => {
          // A failed status check cannot prove that this customer is eligible.
          if (alive && current === generation) conceal();
        }).finally(() => {
          clearTimeout(requestTimer);
          requestTimer = null;
          if (requestController === request) requestController = null;
          if (requestedAgain && alive) { requestedAgain = false; refresh(); }
        });
      };
      close.addEventListener('click', minimize, { signal: controller.signal });
      launcher.addEventListener('click', () => { open(); close.focus({ preventScroll: true }); }, { signal: controller.signal });
      root.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && root.dataset.state === 'open') {
          event.preventDefault(); event.stopPropagation(); minimize();
        }
      }, { signal: controller.signal });
      instances.set(root, { open, refresh, destroy() {
        alive = false; generation++; clearTimeout(revealTimer); clearTimeout(deadlineTimer); clearTimeout(requestTimer);
        requestController?.abort(); controller.abort();
      } });
      refresh();
    });
    if (instances.size) observer.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'hidden', 'open', 'aria-hidden', 'aria-modal'] });
    update();
  };
  const refreshAll = () => instances.forEach((instance) => instance.refresh());
  window.__bpAppDownloadPopup = { init, refresh: refreshAll };
  init(document);
  document.addEventListener('focusin', schedule);
  document.addEventListener('focusout', schedule);
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', refreshAll);
  window.addEventListener('focus', refreshAll);
  window.addEventListener('storage', (event) => { if (event.key === windowKey) refreshAll(); });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refreshAll(); });
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:select', (event) => {
    rootsIn(event.target).forEach((root) => instances.get(root)?.open?.());
  });
  document.addEventListener('shopify:section:unload', (event) => {
    rootsIn(event.target).forEach((root) => {
      instances.get(root)?.destroy(); instances.delete(root);
    });
    if (!instances.size) observer.disconnect();
  });
})();
